import { Component, Input, Output, OnInit, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';

@Component({
	selector: 'app-dashboard-cell',
	templateUrl: './dashboard-cell.component.html',
	styleUrls: ['./dashboard-cell.component.scss']
})
export class DashboardCellComponent implements OnInit {
	@Input() title: string;
	@Input() showFooterLink = false;
	@Input() footerLinkUrl: string;
	@Input() footerLinkText = 'View Details';
	@Input() showTabs = false;
	@Input() tabNames: string[] = [];
	@Input() color = 'white';
	@Input() height = 1;
	@Input() defaultTabName: string;
	@Input() currentTabName: string;
	@Output() onTabChange = new EventEmitter<string>();

	constructor(private router:Router) {}
	ngOnInit() {
		// use first tab name for default if not specified
		if (this.showTabs) {
			if (!this.defaultTabName) {
				this.defaultTabName = this.tabNames[0];
			}
			this.currentTabName = this.defaultTabName;
		}
		// console.log(this.currentTabName, this.defaultTabName, this.tabNames);
	}

	changeTab(name: string) {
		this.currentTabName = name;
		this.onTabChange.emit(name);
	}

	public canDrag():boolean{
		if (this.router.url.toUpperCase().indexOf('/DASHBOARD') >= 0) {
			return true;
		}
		return false;
	}
}

// helper custom elements for transclusion
@Component({
	selector: 'app-dashboard-cell-body',
	template: '<ng-content></ng-content>'
})
export class DashboardCellBodyComponent {
	constructor() {

	}
}
